import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { formatLocalYmd } from '../infra/salesDateRange';
import { openSalesList, type SalesListRouteParams, type BranchSalesHistoryCashierFilter } from './salesNavigation';

export type OpenBranchSalesHistoryOptions = {
  fromYmd: string;
  toYmd: string;
  cashierFilter?: BranchSalesHistoryCashierFilter;
  screenTitle?: string;
};

/** Abre el libro de ventas (pantalla SalesList). */
export function useBranchSalesHistory() {
  const navigation = useNavigation();

  const openSalesHistory = useCallback(
    (options?: OpenBranchSalesHistoryOptions) => {
      const ymd = formatLocalYmd(new Date());
      const params: SalesListRouteParams = {
        fromYmd: options?.fromYmd ?? ymd,
        toYmd: options?.toYmd ?? ymd,
        cashierFilter: options?.cashierFilter ?? 'all',
        screenTitle: options?.screenTitle ?? 'Ventas',
      };
      openSalesList(navigation, params);
    },
    [navigation]
  );

  return { openSalesHistory };
}
